import React, { Component } from 'react';
import FlightListFilters from './flight-list-filters';
import FlightListTable from './flight-list-table';
import EffTable from './eff-table';
import { showBlocker, hideBlocker } from './../../actions/blocker';
import { fetchFlights, updateFlightDetails, setSelectedFlight ,fetchFlightsSearch } from './../../actions/flight-list';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Annotations from './annotations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

class FlightList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showEffId: null,
        };
        const { start, end } = getFlightOptions(this.props.options);
        this.start = start;
        this.end = end;
        this.xhr = null;
        this.interval = null;
        this.onSelectFlight = this.onSelectFlight.bind(this);
        this.onUpdateFlight = this.onUpdateFlight.bind(this);
        this.onShowEff = this.onShowEff.bind(this);
    }

    componentWillMount() {
        console.log(new Date(this.start),new Date(this.end))
        this.props.showBlocker();        
        const search = window.location.search;
        const param = search.split('?')[1];
        if(param ==='archive=false'){
            this.xhr = this.props.fetchFlightsSearch(this.props.options.typeRange, this.start, this.end)
            .always(this.props.hideBlocker);
        }
        else if(param ==='archive=true'){
            this.xhr = this.props.fetchFlights(this.props.options.typeRange, this.start, this.end)
            .always(this.props.hideBlocker);
        }
        else{
            this.xhr = this.props.fetchFlightsSearch(this.props.options.typeRange, this.start, this.end)
            .always(this.props.hideBlocker);
        }
        
        this.interval = window.setInterval(_ => {
            const { start, end } = getFlightOptions(this.props.options);
            this.start = start;
            this.end = end;
            if(param ==='archive=false'){
                this.xhr = this.props.fetchFlightsSearch(this.props.options.typeRange, this.start, this.end);
           
           }
           // else if(param ==='archive=true'){
           //     this.xhr = this.props.fetchFlights(this.props.options.typeRange, this.start, this.end)
           //     .always(this.props.hideBlocker);
           // }
           else{
               this.xhr = this.props.fetchFlightsSearch(this.props.options.typeRange, this.start, this.end);
           }
        }, this.props.options.autoRefresh * 60 * 1000);
    }

    componentWillUnmount() {
        this.xhr && this.xhr.abort();
        this.interval && window.clearInterval(this.interval);
    }

    onSelectFlight(flight) {
        if (this.props.isGenerateEFF) {
            this.props.setSelectedFlight(flight);
            let { id, flt, dep, arr, reg } = flight;
            this.props.history.push(`/flights/${id}?start=${this.start}&end=${this.end}&flt=${flt}&dep=${dep}&arr=${arr}&reg=${reg}`);
        }
    }

    onUpdateFlight(flight, index, server) {
        this.props.updateFlightDetails(flight, index, server);
    }

    onShowEff(flight) {
        this.setState({ showEffId: flight.id });
    }

    render() {
        return (
            <div className='container-fluid d-flex flex-column'>
                {
                    this.state.showEffId ?
                        <div className='position-fixed d-flex align-items-center p-5'
                            style={{ top: 0, right: 0, bottom: 0, left: 0, zIndex: 9 }}>
                            <div className='w-100' style={{ zIndex: 1 }}>
                                <i className='bg-light text-dark float-right px-1 cursor-pointer'
                                    onClick={e => this.setState({ showEffId: null })}>
                                    <FontAwesomeIcon icon={faTimesCircle} /></i>
                                <EffTable id={this.state.showEffId} />
                            </div>
                            <div className='position-fixed bg-light'
                                style={{ opacity: '0.3', top: 0, right: 0, bottom: 0, left: 0 }}></div>
                        </div> : null
                }
                <div id='FlightListFilters'
                    className='row border-bottom py-2'>
                    <FlightListFilters />
                </div>
                <div className='row flex-grow-1'>
                    <div className='col h-100 p-0'>
                        <Annotations count={this.props.flights.length} updated={''} />
                        <FlightListTable flights={this.props.flights}
                            onSelectFlight={this.onSelectFlight}
                            onUpdateFlight={this.onUpdateFlight}
                            onShowEff={this.onShowEff} />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    options: state.flights.options,
    flights: state.flights.flights,
    isViewEFF: state.auth.user.perms.actions.includes('VIEWEFF'),
    isGenerateEFF: state.auth.user.perms.actions.includes('GENERATEEFF'),
});

const mapActionsToProps = { fetchFlights, updateFlightDetails, setSelectedFlight,fetchFlightsSearch,  showBlocker, hideBlocker, };

export default withRouter(connect(mapStateToProps, mapActionsToProps)(FlightList));

function getFlightOptions({ typeRange, dateFrom, dateTo, timeMinus, timePlus }) {
    let start, end;
    if (typeRange === 'date') {
        start = new Date(`${dateFrom} 00:00:00`).getTime();
        end = new Date(`${dateTo} 00:00:00`).getTime() + (24 * 60 * 60 * 1000); // add one day to include the selected date
    } else {
        let currentDateTime = new Date().getTime();
        start = currentDateTime - (timeMinus * 60 * 60 * 1000);
        end = currentDateTime + (timePlus * 60 * 60 * 1000);
    }
    return { start, end }
}